module.exports = "mutation ($ids: [ID!], $data: ResidentialUpdate!) {\n  ResidentialsUpdate(ids: $ids, data: $data) {\n    id\n  }\n}\n"